/**
 * Every modal the app-wide ModalProviderComponent can show. Open one with
 * useModal().openModal(MODAL_KEYS.X, props); add a key here and a component in modalRegistry.ts.
 */
export const MODAL_KEYS = {
  CONSENT_DECLINE: 'consentDecline',
  MERGE_CONFIRM: 'mergeConfirm',
} as const;

export type ModalKey = (typeof MODAL_KEYS)[keyof typeof MODAL_KEYS];
